export const CLIENT_ROUTE_NAMES = {
    LIST: "ClientList",
    PROFILE: "ClientProfile",
    ADD: "ClientAdd",
    EDIT: "ClientEdit",
};
